import UiHelper from './UiHelper';

class LocationMapFactory
{
    static init()
    {
        this.instances = [];

        this.initMaps = this.initMaps.bind(this);
        this.centerMaps = this.centerMaps.bind(this);

        UiHelper.registerHandler('gmapsLoaded', this.initMaps);
        UiHelper.registerHandler('resize', this.centerMaps, 'debounce');
    }

    static initMaps()
    {
        Array.from(UiHelper.getNodes('.js-google-map')).forEach(wrap =>
        {
            this.instances.push(new LocationMap(wrap));
        });
    }

    static centerMaps()
    {
        this.instances.forEach(map => map.recenter());
    }
}
export default LocationMapFactory;

class LocationMap
{
    constructor(wrap)
    {
        this.center = new google.maps.LatLng(wrap.dataset.lat, wrap.dataset.lng);
		this.map = new google.maps.Map(wrap, {
			zoom: 14,
			center: this.center,
			mapTypeId: 'terrain'
		});
        this.marker = new google.maps.Marker({
			position: this.center,
			map: this.map
		});
    }

    recenter()
    {
        this.map.panTo(this.center);
    }
}
